<app-dialog-wrapper [isClosing]="isClosing" (animationend)="onAnimationEnd()">

    <div class="w-full p-2 flex-1">
      <div class="mb-4">
        <h2 class="text-lg font-bold text-center">Choisir un pourboire</h2>
      </div>
      
      <div *ngIf="this.data.returnAmount !== 0" class="grid grid-cols-2 gap-4 mb-4">
        <button (click)="selectTipOption(0)" class="bg-gray-100 py-2 rounded-full font-semibold">Remise à
          zéro</button>
        <button (click)="selectTipOption('arrondi')"
          class="bg-gray-100 py-2 rounded-full font-semibold">Arrondi</button>
        <button (click)="selectTipOption(5)" [ngClass]="[selectedTip === 5 && !useFreeAmount ? 'bg-[#4d47dc] text-white' : 'bg-gray-100',
        'py-2 rounded-full font-semibold']">5%</button>
        <button (click)="selectTipOption(10)" [ngClass]="[selectedTip === 10 && !useFreeAmount ? 'bg-[#4d47dc] text-white' : 'bg-gray-100',
        'py-2 rounded-full font-semibold']">10%</button>

      </div>

      <div class="flex items-center justify-center gap-2 mb-4">
        <button mat-mini-fab color="primary" (click)="decreaseFreeAmount()">
          <mat-icon>remove</mat-icon>
        </button>
        <div class="flex items-center gap-1">
          <input type="number" step="0.01" min="0" [(ngModel)]="freeAmount"
            class="w-24 text-center border rounded px-2 py-1" (ngModelChange)="onFreeAmountChange()"
            placeholder="0.00" />
          <span class="text-gray-500">{{ data.currencySymbol }}</span>
        </div>
        <button mat-mini-fab color="primary" (click)="increaseFreeAmount()">
          <mat-icon>add</mat-icon>
        </button>
      </div>

      <div class="mx-auto max-w-2xl m-4 w-full">
        <button *ngIf="freeAmount <= 0" (click)="onCancel()"
          class="bg-white w-full font-bold text-lg py-4 shadow-md rounded-full">
          Non merci
        </button>
        <button *ngIf="freeAmount > 0" (click)="onConfirm()"
          class="w-full text-white font-bold text-lg py-4 bg-[#4d47dc] shadow-md rounded-full">
          Valider
        </button>
      </div>
    </div>
</app-dialog-wrapper>